import type { Components, Theme } from '@mui/material';

import { palette } from '../';

export const getMuiOutlinedInput = (): Components<Theme>['MuiOutlinedInput'] => ({
    styleOverrides: {
        root: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.border?.main,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.border?.hovered,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
            },
            '& .MuiIconButton-root': {
                color: palette.icon?.primary,
            },
        },
    },
});
